'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var dataMgr = require('./data-mgr');

var state;

var sendEventLink = function($form) {

	$.ajax({

		type: 'POST',
		url: dataMgr.getEventUrl() + '?page=send_event_link',
		dataType: 'JSON',
		data: $form.serialize()

	}).done(function(response) {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var loadSocialAccounts = function(data) {

	$.ajax({

		type: 'POST',
		url: dataMgr.getEventUrl() + '?page=load_social_accounts',
		dataType: 'JSON',
		data: data

	}).done(function(response) {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var getShareUrl = function(opts) {

	var url = location.protocol + '//' + location.hostname + dataMgr.getEventUrl();

	opts = opts || {};

	url += (opts.photoUrl ? '/' + opts.photoUrl : '');
	url += '?key=' + dataMgr.getEventKey();

	return url;

};

var addEventHandlers = function() {

	appDom.document.on('slideshow_share_btn_clicked.social main_nav_share_clicked.social', function(e) {

		var imageMeta;

		if (e.type === 'slideshow_share_btn_clicked') {

			imageMeta = dataMgr.getImageMeta();
			state.pendingData.photoId = imageMeta.photoId;
			state.shareUrl = getShareUrl({
				photoUrl: imageMeta.galleryFriendlyName + '/' + imageMeta.friendlyName
			});
			state.shareImage = dataMgr.getImageUrl('xlarge', { imageIndex: imageMeta.index });

		} else {

			// No specific photo information should be used when sharing from the menu.
			state.pendingData = {};
			state.shareUrl = getShareUrl();
			state.shareImage = dataMgr.getEventDefaultShareImage();

		}

		loadSocialAccounts(state.pendingData);

	});

	appDom.document.on('load_social_accounts.social', function() {

		loadSocialAccounts(state.pendingData);

	});

	appDom.document.on('social_accounts_loaded.social', function(e, data) {

		sidePanel.open(data.response.markup, {type: 'share'});

	});

	appDom.document.on('social_email_invalid.social', function(e, data) {

		$('.modal__social-send-email-button').text(window.pbizServer.content.send);

		notify.show({
			target: $('[name="email"]'),
			container: '.modal__social-share-form',
			msg: data.response.status.msg
		});

	});

	appDom.document.on('social_message_invalid.social', function(e, data) {

		$('.modal__social-send-email-button').text(window.pbizServer.content.send);

		notify.show({
			target: $('[name="message"]'),
			container: '.modal__social-share-form',
			msg: data.response.status.msg
		});

	});

	appDom.document.on('social_email_sent.social', function() {

		$.ajax({
			type: 'POST',
			url: dataMgr.getEventUrl() + '?page=message_sent',
			dataType: 'JSON'
		}).done(function(response) {

			sidePanel.open(response.markup);

		});

	});

	appDom.document.on('click.social', '.modal__social-send-email-button', function() {

		$(this).text(window.pbizServer.content.loading);

		sendEventLink($(this).closest('form'));

	});

	appDom.document.on('click.social', '.modal__social-icon', function(e) {

		var $target = $(e.target);
		var url = '/social/social_networking.cfm?type=proofing&external=true&networkID=';
		var title = dataMgr.getEventName();

		if ($target.is('.modal__social-icon--facebook')) {

			url += 'facebook';

		} else if ($target.is('.modal__social-icon--twitter')) {

			url += 'twitter&text=' + dataMgr.getEventName() + ' images by ' + dataMgr.getPhotographerCompanyName();

		} else if ($target.is('.modal__social-icon--google-plus')) {

			url += 'google-plus';

		} else if ($target.is('.modal__social-icon--pinterest')) {

			url += 'pinterest&image_url=' + state.shareImage;
			title += ' Images by ' + dataMgr.getPhotographerCompanyName();

		}

		url += '&title=' + title;
		url += '&linkBack=' + window.encodeURIComponent(state.shareUrl + '&ts=' + Date.now());

		window.open(url, '_blank');

	});

};

var setupInitialState = function() {

	state = {
		pendingData: {},
		shareUrl: '',
		shareImage: ''
	};

};

var init = function() {

	setupInitialState();
	addEventHandlers();

};

module.exports = {
	init: init
};
